import {
    Component
} from '@angular/core';
@Component({
    selector: 'bigbools-component',
    template: require('./bigbools.component.html'),
    styles: [require('./bigbools.component.css')]
})

export class BigboolsComponent {

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/bigbools/bigbools.component.ts